import React, { useRef } from "react"
import Container from "../../atoms/Container"
import styled from "styled-components"
import { Composition, useResponsiveValue, query } from "atomic-layout"
import Button from "../../atoms/Button"
import Image from "../../organisms/Image"
import { gap } from "../../../utils/spacing"
import Background from "../../molecules/Background"
import Overline from "../../molecules/Overline"

const StyledContainer = styled(Container)`
  overflow: hidden;
  border-top: 4px solid #C69214;
  border-bottom: 4px solid #C69214;
  p {
    font-size: var(--callout-text-size);
  }
`

const StyledContent = styled.div`
  padding: clamp(64px, 8.3vw, 128px) 0;
  max-width: 680px;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
  color: #fff;
  @media ${query({from: "lg"})}{
    /* min-height: 540px; */
  }
`

const StyledOverline = styled(Overline)`
  margin-left: -16px;
`

const FullBackgroundHeroSection = ({
                       heading = null,
                       image = {},
                       buttonUrl,
                       buttonText,
                       video = {},
                       goldOverlineText = null,
                       blueOverlineText = null,
                       text = ""
                     }) => {
  const contentRef = useRef(null)
  
  const marginTop = useResponsiveValue(
    {
      md: "80px",
      lg: "2rem"
    },
    "20px"
  )

  return (
    <StyledContainer removeVerticalSpacing
                     containerProps={{ style: { marginTop: 0, marginBottom: "var(--section-spacing)" } }}
                     background={<Background image={image} video={video} overlay="rgba(0, 0, 0, 0.6)"/>}
                     >
      <StyledContent ref={contentRef} style={{ position: "relative" }}>
          <div style={{ position: "relative" }}>
            {goldOverlineText && <Overline text={goldOverlineText} />}
            {blueOverlineText && <StyledOverline text={blueOverlineText} color="#003057" />}
            {heading}
            {text}
            {buttonUrl && buttonText &&
            <Button to={buttonUrl?.url} target={buttonUrl?.target} primary>{buttonText}</Button>
            }
          </div>
      </StyledContent>
    </StyledContainer>
  )
}

export default FullBackgroundHeroSection
